import { useEffect } from 'react'
import { Organization } from '../types'

/**
 * Aplica la identidad visual de la empresa a toda la plataforma.
 * Escribe variables CSS en :root, de modo que CRM, formularios y landings
 * heredan automáticamente los colores y las tipografías configuradas.
 */
export function useBrandTheme(organization: Organization | null): void {
  useEffect(() => {
    const root = document.documentElement
    const brand = organization?.brand

    const vars: Record<string, string | undefined> = {
      '--primary': brand?.primaryColor,
      '--navy': brand?.secondaryColor,
      '--brand-button': brand?.buttonColor || brand?.primaryColor,
      '--brand-text': brand?.textColor,
      '--brand-bg': brand?.backgroundColor,
      '--font-primary': brand?.fontFamily ? `'${brand.fontFamily}'` : undefined,
      '--font-secondary': brand?.secondaryFontFamily
        ? `'${brand.secondaryFontFamily}'`
        : brand?.fontFamily
          ? `'${brand.fontFamily}'`
          : undefined,
    }

    const applied: string[] = []
    Object.entries(vars).forEach(([key, value]) => {
      if (value) {
        root.style.setProperty(key, value)
        applied.push(key)
      }
    })

    return () => {
      applied.forEach((key) => root.style.removeProperty(key))
    }
  }, [organization])
}
